import { cn } from "@/utils/cn";
import useTranslation from "@babackapp/translations/use-translation";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandSeparator,
} from "@babackapp/ui/components/command";
import { Check } from "lucide-react";
import type { ElementType } from "react";

interface CommandCheckboxesOption {
  value: string;
  label: string;
  Icon?: ElementType;
}

interface CommandCheckboxesProps {
  options: CommandCheckboxesOption[];
  value?: string;
  onSelect: (value: string, isSelected: boolean) => void;
  onClear: () => void;
  inputPlaceholder?: string;
  withInput?: boolean;
  withClear?: boolean;
}

export default function CommandSelect({
  options,
  onSelect,
  onClear,
  inputPlaceholder,
  value,
  withInput = true,
  withClear = true,
}: CommandCheckboxesProps) {
  const t = useTranslation();
  return (
    <Command>
      {withInput && <CommandInput placeholder={inputPlaceholder} />}
      <CommandList>
        <CommandEmpty>{t("misc.noResultFound")}</CommandEmpty>
        <CommandGroup>
          {options.map((option) => {
            return (
              <CommandItem
                key={option.value}
                onSelect={() => {
                  onSelect(option.value, value === option.value);
                }}
                className={"flex-row items-center justify-between"}
              >
                <div className={"flex flex-row flex-1 items-center"}>
                  {option.Icon && (
                    <div className={"mr-1"}>
                      <option.Icon className={"h-4 w-4"} />
                    </div>
                  )}
                  <span>{option.label}</span>
                </div>
                <div className={cn(value !== option.value ? "hidden" : "")}>
                  <Check className={"h-4 w-4"} />
                </div>
              </CommandItem>
            );
          })}
        </CommandGroup>
        {withClear && (
          <>
            <CommandSeparator />
            <CommandGroup>
              <CommandItem
                onSelect={onClear}
                className="justify-center text-center"
              >
                {t("misc.filters.clear")}
              </CommandItem>
            </CommandGroup>
          </>
        )}
      </CommandList>
    </Command>
  );
}
